"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pluralize;
var pluralRules = new Intl.PluralRules('en-US');

function pluralize(count, singular, plural) {
  var grammaticalNumber = pluralRules.select(count);

  switch (grammaticalNumber) {
    case 'one':
      return "".concat(count, " ").concat(singular);

    case 'other':
      return "".concat(count, " ").concat(plural);

    default:
      return "".concat(count, " ").concat(singular);
  }
}